import classNames from 'classnames';

type ChapterDividerProps = {
  title?: string;
  className?: string;
};

export const ChapterDivider = ({ title, className }: ChapterDividerProps) => {
  return (
    <div
      className={classNames('mb-4 flex w-full items-center gap-2', className)}
    >
      <small className="shrink-0 text-[12px]">{title}</small>
      <span className="h-[1px] w-full bg-easy"></span>
    </div>
  );
};
